import { Box, Image, Text } from "grommet";
import React from "react";
import Avatar from "react-avatar";
import SkeletonWrapper from "../components/SkeletonWrapper";
import { TournamentViewModel } from "./TournamentsStore";

const TournamentBlock = ({ tournament }: { tournament: TournamentViewModel }) => {
    return (
        <Box direction="row-responsive" align="center">
            {!tournament.id && (
                <SkeletonWrapper loading={true}>
                    <></>
                </SkeletonWrapper>
            )}
            {tournament.id && (
                <Box align="center" gap="small" pad="small">
                    {tournament.logoUri && <Image src={tournament.logoUri} alt="" style={{ maxHeight: "35px", objectFit: "contain" }} />}
                    {!tournament.logoUri && <Avatar name={tournament.name} alt="" size="35px" />}
                    <Text textAlign="center">{tournament.name}</Text>
                </Box>
            )}
        </Box>
    );
};

export default TournamentBlock;
